/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { shadowColor } from 'theme/color';

import createTheme, {
  Card,
  Box,
  Grid,
  Button,
  InputAdornment,
  Typography,
} from '@mui/material';
import C3Chart from 'react-c3js';
import {
  fontsize24,
  poppins500,
  poppins400,
  displayFlex,
} from 'theme/common.style';
import CalendarMonthTwoToneIcon from '@mui/icons-material/CalendarMonthTwoTone';
import AttachMoneyTwoToneIcon from '@mui/icons-material/AttachMoneyTwoTone';
import PercentTwoToneIcon from '@mui/icons-material/PercentTwoTone';
import TextField from '@mui/material/TextField';
import { alignCenter } from 'component/VendorStatusContainer/VendorStatusContainer.style';
import { AlignHorizontalLeft } from '@mui/icons-material';
import { displayFlexRow } from 'component/ActivityContainer/ActivityContainer.style';
import { inputComponent, inputButton } from './PropertyProfile.style';
import 'c3/c3.css';

import {
  mortColorCont,
  mortGridValue,
  underlineText,
} from './PropertyProfileDetails.Style';

const data = {
  columns: [
    ['data1', 30],
    ['data2', 120],
  ],
  type: 'donut',
  donut: {
    title: 'Iris Petal Width',
  },
};

const donut = {
  legend: {
    show: false,
  },
  data: {
    columns: [
      ['data1', 30],
      ['data2', 120],
    ],
    type: 'donut',
  },
  donut: {
    title: 'Mortgage',
  },
  label: {
    show: false,
  },
};

const propertyMortage = [
  {
    name: 'Principle Interest',
    color: '#FED26C',
    value: '$3,500.00',
  },
  {
    name: 'Property Tax',
    color: '#70F07D',
    value: '$250.00',
  },
  {
    name: 'Home Insurance',
    color: '#75CFFD',
    value: '$88.00',
  },
  {
    name: 'PMI',
    color: '#FC64BF',
    value: '$1000.00',
  },
];

function PropertyProfileMortageCalculator(props) {
  const [chartData, setChartData] = useState(donut);

  return (
    <Card
      variant="outlined"
      style={{
        borderRadius: '8px',
        boxShadow: `0px 1px 8px ${shadowColor}`,
        padding: '30px 20px',
        marginTop: '14px',
      }}
    >
      <Grid>
        <Grid sx={{ ...poppins500, ...fontsize24 }}>Mortgage Calculator</Grid>
        <Grid
          sx={displayFlex}
          container
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
        >
          <Grid xs={6} sm={6} md={6} lg={6} xl={6}>
            <C3Chart {...chartData} />
          </Grid>
          <Grid xs={6} sm={6} md={6} lg={6} xl={6}>
            <Card
              variant="outlined"
              style={{
                borderRadius: '8px',
                boxShadow: `0px 1px 8px ${shadowColor}`,
                padding: '20px',
              }}
            >
              {propertyMortage.map((propMort, index) => (
                <>
                  <Grid
                    sx={displayFlex}
                    style={{
                      alignItems: 'center',
                      paddingTop: '10px',
                    }}
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    container
                    gap={2}
                  >
                    <Grid
                      sx={mortColorCont(propMort.color)}
                      xs={1}
                      sm={1}
                      md={1}
                      lg={1}
                      xl={1}
                    />
                    <Grid
                      sx={{ ...poppins500, ...fontsize24 }}
                      xs={6}
                      sm={6}
                      md={6}
                      lg={6}
                      xl={6}
                    >
                      {propMort.name}
                    </Grid>
                    <Grid sx={mortGridValue} xs={4} sm={4} md={4} lg={4} xl={4}>
                      {propMort.value}
                    </Grid>
                  </Grid>
                  {index !== 3 && <Grid sx={underlineText} />}
                </>
              ))}
            </Card>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        gap={2}
        xs={12}
        sm={12}
        md={12}
        lg={12}
        xl={12}
        container
        sx={{
          borderRadius: '10px',
          display: 'flex',
          flexDirection: 'row',
          backgroundColor: '#F8F8F8',
          padding: '20px 40px',
        }}
      >
        <Grid
          xs={3}
          sm={3}
          md={3}
          lg={3}
          xl={3}
          color="#666666"
          display="flex"
          flexDirection="column"
          sx={{ ...poppins400, ...fontsize24 }}
        >
          Total Amount
          <TextField
            style={inputComponent}
            id="outlined-basic"
            variant="outlined"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AttachMoneyTwoToneIcon
                    style={{
                      paddingRight: '6px',
                      borderRight: '1px solid black',
                      color: '#000000',
                    }}
                  />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid
          xs={3}
          sm={3}
          md={3}
          lg={3}
          xl={3}
          color="#666666"
          display="flex"
          flexDirection="column"
          sx={{ ...poppins400, ...fontsize24 }}
        >
          Total Amount
          <TextField
            style={inputComponent}
            id="outlined-basic"
            variant="outlined"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AttachMoneyTwoToneIcon
                    style={{
                      paddingRight: '6px',
                      borderRight: '1px solid black',
                      color: '#000000',
                    }}
                  />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid
          xs={3}
          sm={3}
          md={3}
          lg={3}
          xl={3}
          color="#666666"
          display="flex"
          flexDirection="column"
          sx={{ ...poppins400, ...fontsize24 }}
        >
          Total Amount
          <TextField
            style={inputComponent}
            id="outlined-basic"
            variant="outlined"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <PercentTwoToneIcon
                    style={{
                      paddingRight: '6px',
                      borderRight: '1px solid black',
                      color: '#000000',
                    }}
                  />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid
          xs={3}
          sm={3}
          md={3}
          lg={3}
          xl={3}
          columnGap={3}
          color="#666666"
          display="flex"
          flexDirection="column"
          sx={{ ...poppins400, ...fontsize24 }}
        >
          <Typography sx={{ ...poppins400, ...fontsize24 }}>
            Loan Terms
          </Typography>
          <TextField
            style={inputComponent}
            id="outlined-basic"
            variant="outlined"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <CalendarMonthTwoToneIcon
                    style={{
                      paddingRight: '6px',
                      borderRight: '1px solid black',
                      color: '#000000',
                    }}
                  />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid
          xs={3}
          sm={3}
          md={3}
          lg={3}
          xl={3}
          color="#666666"
          display="flex"
          flexDirection="column"
          sx={{ ...poppins400, ...fontsize24 }}
        >
          Property Tax
          <TextField
            style={inputComponent}
            id="outlined-basic"
            variant="outlined"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AttachMoneyTwoToneIcon
                    style={{
                      paddingRight: '6px',
                      borderRight: '1px solid black',
                      color: '#000000',
                    }}
                  />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid
          xs={3}
          sm={3}
          md={3}
          lg={3}
          xl={3}
          color="#666666"
          display="flex"
          flexDirection="column"
          sx={{ ...poppins400, ...fontsize24 }}
        >
          Home Insurance
          <TextField
            style={inputComponent}
            id="outlined-basic"
            variant="outlined"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <PercentTwoToneIcon
                    style={{
                      paddingRight: '6px',
                      borderRight: '1px solid black',
                      color: '#000000',
                    }}
                  />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid
          xs={3}
          sm={3}
          md={3}
          lg={3}
          xl={3}
          color="#666666"
          display="flex"
          flexDirection="column"
          sx={{ ...poppins400, ...fontsize24 }}
        >
          Total Amount
          <TextField
            style={inputComponent}
            id="outlined-basic"
            variant="outlined"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <PercentTwoToneIcon
                    style={{
                      paddingRight: '6px',
                      borderRight: '1px solid black',
                      color: '#000000',
                    }}
                  />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
      </Grid>
      <Grid container>
        <Grid
          item
          sx={{
            display: 'flex',
          }}
        >
          <Grid container padding={5}>
            <Grid
              xs={12}
              display="flex"
              flexDirection="row"
              justifyContent="flex-start"
              alignItems="center"
              sx={{ ...poppins500, ...fontsize24 }}
            >
              <Button style={inputButton} variant="contained">
                Calculate
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
}

PropertyProfileMortageCalculator.propTypes = {};

export default PropertyProfileMortageCalculator;
